import { NdmsHomeService } from './../../../components/home/home.service';
import { Injectable, Injector } from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, Resolve, Router, CanActivate, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import { skipWhile } from 'rxjs/operators';
import { NdmsAuthService } from "./ndms-auth.service";

@Injectable()
export class NdmsAuthenticationGuard implements CanActivate, Resolve<any> {

  constructor(private authService: NdmsAuthService, private homeService: NdmsHomeService) {
  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any | Observable<any> | Promise<any> {
    return new Promise<any>((resolve, reject) => {  
      this.authService.bearerToken$.pipe( skipWhile(v => !this.authService.isValidToken(v)) ).subscribe(() => {
        if (this.homeService.initialApplicationsLoaded) {
          this.homeService.getAllApplications().then(() => this.homeService.setUserApplications().then((userApps) => {
            this.homeService.initialApplicationsLoaded = true;
            resolve(userApps);
          }));
        } else {
          resolve([]);
        }
      });
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return true;
  }
}
